// extracted by mini-css-extract-plugin
module.exports = {"component":"_3L049","statusInfo":"_2_cJW","link":"_3y7uB","iconWrapper":"_2x_Bd","icon":"_3yhSr","spinnerContainer":"_2tGFr","spinner":"_3yOFZ"};